<div id="acc-root" class="acc-overlay" (click)="onClose()">
  <section
    class="acc-card ec-card"
    role="dialog"
    aria-modal="true"
    aria-labelledby="qc-title"
    (click)="$event.stopPropagation()">

    <h2 id="qc-title">{{ 'componentsWizard.queueCreate.title' | translate }}</h2>
    <p class="qc-subtitle">{{ 'componentsWizard.queueCreate.subtitle' | translate }}</p>

    <form class="acc-form ec-form" [formGroup]="form" (ngSubmit)="submit()">
      <!-- Nom FR -->
      <div class="acc-field">
        <label>{{ 'componentsWizard.queueCreate.nameLabelFr' | translate }}</label>
        <input class="acc-input ec-input" type="text" formControlName="name" [placeholder]="'componentsWizard.queueCreate.namePlaceholder' | translate" />
      </div>

      <!-- Champs i18n pour les autres langues -->
      <ng-container *ngFor="let lang of langues">
        <div class="acc-field" *ngIf="lang !== 'fr'">
          <label>{{ 'componentsWizard.queueCreate.nameLabelLang' | translate: { lang: (lang === 'ar' ? 'AR' : lang.toUpperCase()) } }}</label>
          <input class="acc-input ec-input" type="text" [formControlName]="'name_' + lang" [dir]="lang === 'ar' ? 'rtl' : 'ltr'" />
        </div>
      </ng-container>

      <!-- Message patient FR -->
      <div class="acc-field">
        <label>{{ 'componentsWizard.queueCreate.patientMessageLabelFr' | translate }}</label>
        <textarea class="acc-input ec-input ec-textarea" rows="3"
                  formControlName="patient_message"
                  [placeholder]="'componentsWizard.queueCreate.patientMessageDefault' | translate"></textarea>
      </div>

      <!-- Champs i18n pour les autres langues -->
      <ng-container *ngFor="let lang of langues">
        <div class="acc-field" *ngIf="lang !== 'fr'">
          <label>{{ 'componentsWizard.queueCreate.patientMessageLabelLang' | translate: { lang: (lang === 'ar' ? 'AR' : lang.toUpperCase()) } }}</label>
          <textarea class="acc-input ec-input ec-textarea" rows="3"
                    [formControlName]="'patient_message_' + lang"
                    [dir]="lang === 'ar' ? 'rtl' : 'ltr'"></textarea>
        </div>
      </ng-container>

      <div *ngIf="errorMsg" class="acc-msg acc-msg--error">{{ errorMsg }}</div>

      <div class="acc-actions ec-actions">
        <button type="button" class="acc-btn acc-cancel" [disabled]="loading" (click)="onClose()">
          {{ 'componentsWizard.queueCreate.cancel' | translate }}
        </button>
        <button class="acc-btn acc-primary" type="submit" [disabled]="loading || form.invalid">
          {{ (loading ? 'componentsWizard.queueCreate.creating' : 'componentsWizard.queueCreate.create') | translate }}
        </button>
      </div>
    </form>
  </section>
</div>